import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
export const ItemsListing = ({ devices, remove }) => {
  return (
    <section className={styles.container}>
      <header className={styles.containerHeader}>
        <p>Items</p>
        {/* <FaRegEdit size={20} onClick={() => updateBox(boxDetails)} /> */}
      </header>
      <main className={styles.devicesContainer}>
        <main className={styles.devicesListing}>
          {devices?.map((_device, index) => (
            <section key={_device.device_type} className={styles.device}>
              <h5>{index + 1}</h5>
              <section className={styles.deviceInput}>
                <h5>Device Name</h5>
                <p>{_device.name}</p>
              </section>
              <section className={styles.deviceInput}>
                <h5>Quantity</h5>
                <p>{_device.quantity}</p>
              </section>
              {remove && (
                <section className={styles.deviceInput}>
                  <FontAwesomeIcon
                    className={styles.action}
                    icon={faTrash}
                    onClick={() => remove(_device.device_type)}
                  />
                </section>
              )}
            </section>
          ))}
        </main>
      </main>
    </section>
  );
};

export default ItemsListing;
